module.exports = __webpack_public_path__ + "img/logo.e184f278.png";